
import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-20 bg-gradient-to-br from-teal-500 via-teal-600 to-blue-600 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/10"></div>
      
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          あなたの会社売買も<br />
          NEXTAGEにお任せください
        </h2>
        <p className="text-xl text-white/90 mb-10 leading-relaxed">
          豊富な実績と確かなノウハウで、<br />
          最適な成約をサポートいたします
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/contact"
            className="inline-flex items-center justify-center px-8 py-4 bg-white text-teal-600 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line mr-2 text-xl"></i>
            無料相談はこちら
          </Link>
          <Link
            to="/company-list"
            className="inline-flex items-center justify-center px-8 py-4 bg-teal-700 text-white rounded-lg font-bold text-lg hover:bg-teal-800 transition-colors shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-building-line mr-2 text-xl"></i>
            売却案件を見る
          </Link>
        </div>
      </div>
    </section>
  );
}
